/**
 * defa.views.UnitTestFeedbackView
 * A view for Feedback at the end of unit tests.
 * Note: This is a special view, acting like a FormEnabled view, but it's not a form at all.
 * @version 1.2.0
 */
import View     from 'scripts/poppet/view';
import template from 'templates/unitTestFeedbackView.jst.html';

const channelUser = Bb.Radio.channel( 'user' );

const selectors = {
	buttonTest     : '[data-click=feedback-retest]',
	buttonVerify   : '[data-click=feedback-verify]',
	buttonClose    : '[data-click=feedback-close]',
	buttonLogin    : '[data-click=user-login]',
	inputTestedBoth: '[data-input=tested-both]',
};

const UnitTestFeedbackView = View.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	template: template,
	
	ui: {
		test      : selectors.buttonTest,
		verify    : selectors.buttonVerify,
		close     : selectors.buttonClose,
		login     : selectors.buttonLogin,
		testedBoth: selectors.inputTestedBoth,
	},
	
	events: {
		'click  @ui.test'      : 'onClickTest',
		'click  @ui.verify'    : 'onClickVerify',
		'click  @ui.close'     : 'onClickClose',
		'click  @ui.login'     : 'onClickLogin',
		'change @ui.testedBoth': 'onChangeTestedBoth',
	},
	
	templateContext: function () {
		return {
			feedback      : this.feedback,
			loggedIn      : channelUser.request( 'is:logged:in' ),
			showTestedBoth: this.showTestedBoth(),
		};
	},
	
	// ------------------------------------------------
	// Event handlers
	// ------------------------------------------------
	
	/**
	 * @constructor
	 */
	initialize: function ( options ) {
		this.options = options || {};
		
		this.listenTo( this.model, 'error', function ( model, response ) {
			this.addErrorMessage( response.responseJSON );
		} );
		
		this.feedback = this.options.feedback || 'error';
	},
	
	/**
	 * Triggers when a user clicks the retest button.
	 * @void
	 */
	onClickTest: function () {
		this.busy();
		this.trigger( 'retest' );
	},
	
	/**
	 * Triggers when a user clicks the verify button.
	 * @void
	 */
	onClickVerify: function () {
		this.busy();
		this.trigger( 'verify' );
	},
	
	/**
	 * Triggers when a user clicks the close button.
	 * @void
	 */
	onClickClose: function () {
		this.busy();
		this.trigger( 'close' );
	},
	
	/**
	 * Triggers when a user clicks the login button.
	 * @void
	 */
	onClickLogin: function ( event ) {
		event.preventDefault();
		this.busy();
		this.trigger( 'verify' );
	},
	
	/**
	 * Tiggers when the tested-both checkbox is changed.
	 * @void
	 */
	onChangeTestedBoth: function () {
		
		if ( this.ui.testedBoth.is( ':checked' ) ) {
			this.ui.close.removeAttr( 'disabled' );
			this.ui.verify.removeAttr( 'disabled' );
		} else {
			this.ui.close.prop( 'disabled', true );
			this.ui.verify.prop( 'disabled', true );
		}
	},
	
	// -----------------------------------------
	// Other functions
	// -----------------------------------------
	
	/**
	 * Finds out if the checkbox should be shown or not.
	 * @void
	 */
	showTestedBoth: function () {
		let user = channelUser.request( 'model' );
		
		return ( this.options.hasWarmUp && user.hasRoles( [ 'INSTALLER_AUTOMOTIVE', ] ) && !user.hasRoles( [ 'TECHNICAL_SUPPORT' ] ) );
	},
	
	/**
	 * Cleans old errors and triggers new ones.
	 * @void
	 */
	addErrorMessage: function ( options ) {
		let fieldset = this.$el.find( 'fieldset:not(.button-wrap)' ).last(),
			html5    = '<p class="error">%s</p>'.replace( '%s', options.message );
		
		fieldset.find( '.error' ).remove();
		fieldset.append( html5 );
	},
	
} );

export default UnitTestFeedbackView;